<template>
    <div class="info-list">
        <ul v-if="info.ready">
            <li>
                <div class="left">
                    <p>配送服务</p>
                </div>
                <div class="right">
                    <p>{{info.delivery}}</p>
                </div>
            </li>
            <li v-if="!easyUser">
                <div class="left">
                    <p>我的余额</p>
                </div>
                <div class="right" :class="{'error': (info.payPoint && info.balancePoint < info.payPoint)}">
                    <p>{{info.balancePoint}}{{pointUnit}}</p>
                </div>
            </li>
            <template v-for="(fee, index) in info.feeList" >
                <li :key="'fee-'+index">
                    <div class="left">
                        <p>{{fee.name}}</p>
                    </div>
                    <div class="right">
                        <p>{{fee.point}}{{pointUnit}}</p>
                    </div>
                </li>
            </template>
            
        </ul>
        <ul v-else>
            <li>
                <p class="empty-tip">加载中...</p>
            </li>
        </ul>
    </div>
</template>
<script>
    import api from "../../api";
    import store from "../../api/store";
    
    export default {
        props: ['info'],
        data(){
            return {
                pointUnit: api.store.loginedUser.config.pointName,
                easyUser: store.loginedUser.easyUser,
            }
        }
    }
</script>
<style scoped lang="less">
p {
    margin: 0;
}
.info-list {
    background: #fff;
    margin-top: 2.66666vw;
    // padding-bottom: 28vw;


    ul li {
        padding: 4vw 0;
        font-size: 3.466666vw;
        margin: 0 4vw;
        display: flex;
        justify-content: space-between;
        // border-bottom: 1px solid #e6e6e6;
    }

    ul li:last-child {
        border-bottom: 0;
    }

    .right {
        font-weight: bold;

        &.error{
            color: red;
        }
    }

    .empty-tip{
        text-align: center;
        width: 100%;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/payment/info-list.vue